import React from 'react'
import OfferSelector from '../../PromotionRadioBtn'
import { SectionCard } from './SectionCard'
import styles from './styles.module.css'

export const PromotionsSection = ({ offers, setOffers }) => (
  <SectionCard title='Promotions'>
    <div className={styles.promotionsDesc}>
      Offering promotions attracts more customers and increases sales.
    </div>
    <OfferSelector offers={offers} setOffers={setOffers} />
  </SectionCard>
)
